import { GOOGLE_GEOCODE_API_URL, MAP_API_KEY } from "aster-foundation/core/common/utils/ApiConst";

const getCountry = async (latitude, longitude) => {
  const result = await fetch(
    `${GOOGLE_GEOCODE_API_URL}geocode/json?latlng=${latitude},
    ${longitude}&key=${MAP_API_KEY}`,
  );
  const response = await result.json();
  if (response) {
    const resul = response?.results?.find((res) => res?.types?.includes('country'))?.address_components;
    return resul?.find((addRes) => addRes?.types?.includes('country'))?.short_name;
  }
  return null;
};

const successPositions = async (position) => {
  const { latitude, longitude } = position.coords || {};
  const countryName = await getCountry(encodeURI(latitude), encodeURI(longitude));
  localStorage.setItem('userCountry', countryName);
};

const errorPositions = () => {
  // eslint-disable-next-line no-console
  console.log('location fetching error');
};

// eslint-disable-next-line import/prefer-default-export
export const getUserCountry = () => {
  try {
    if (!navigator.geolocation) {
      return;
    }
    navigator.geolocation.getCurrentPosition(successPositions, errorPositions);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('user location fetching error', e);
  }
};
